import { render } from "./reportResult.vue?vue&type=template&id=19274fce&scoped=true"
import script from "./reportResult.vue?vue&type=script&lang=js"
export * from "./reportResult.vue?vue&type=script&lang=js"

import "./reportResult.vue?vue&type=style&index=0&id=19274fce&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19274fce"]])

export default __exports__